import axios from "axios"
import { supabase } from "../supabaseClient"

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL ? `${process.env.REACT_APP_SERVER_URL}/api/whatsapp` : "/api/whatsapp",
  headers: {
    "Content-Type": "application/json",
  },
})

api.interceptors.request.use(
  async (config) => {
    const {
      data: { session },
    } = await supabase.auth.getSession()

    if (session) {
      config.headers["user-id"] = session.user.id
    }

    // Check if admin has selected a company
    try {
      const selectedCompanyName = localStorage.getItem("selectedCompanyName")
      if (selectedCompanyName) {
        config.headers["x-company-name"] = selectedCompanyName
      }
    } catch (e) {
      // Silently fail if localStorage access fails
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export interface WhatsAppPhoneNumber {
  id: number
  phone_number: string
  friendly_name: string | null
  company_name: string
  agent_id: string | null
  created_at: string
  updated_at: string
  is_active: boolean
  capabilities: string[]
  country_code: string | null
  provider: string | null
}

export const whatsappPhoneNumberService = {
  list: async (companyName?: string): Promise<WhatsAppPhoneNumber[]> => {
    const url = companyName ? `/phone-numbers?company_name=${encodeURIComponent(companyName)}` : "/phone-numbers"
    const response = await api.get<WhatsAppPhoneNumber[]>(url)
    return response.data
  },

  get: async (phoneNumberId: number): Promise<WhatsAppPhoneNumber> => {
    const response = await api.get<WhatsAppPhoneNumber>(`/phone-numbers/${phoneNumberId}`)
    return response.data
  },

  assignAgent: async (phoneNumberId: number, agentId: string | null): Promise<WhatsAppPhoneNumber> => {
    const response = await api.patch<WhatsAppPhoneNumber>(`/phone-numbers/${phoneNumberId}`, {
      agent_id: agentId,
    })
    return response.data
  },

  updateFriendlyName: async (phoneNumberId: number, friendlyName: string): Promise<WhatsAppPhoneNumber> => {
    const response = await api.patch<WhatsAppPhoneNumber>(`/phone-numbers/${phoneNumberId}`, {
      friendly_name: friendlyName,
    })
    return response.data
  },

  delete: async (phoneNumberId: number): Promise<void> => {
    await api.delete(`/phone-numbers/${phoneNumberId}`)
  },
}
